import React from 'react';
import shopifySVG from '../../asstes/Shopify1.svg';
import woocommerceSVG from '../../asstes/woocommerce.svg';
import webflowSVG from '../../asstes/webflow.svg';
import bigcommerceSVG from '../../asstes/bigcommerce.svg';
import googleAnalyticsSVG from '../../asstes/google-analytics.svg';
import prestashopSVG from '../../asstes/Prestashop.svg';
import optimizelySVG from '../../asstes/optimizely.svg';
import wixSVG from '../../asstes/Wix-tech.svg';
import wordpressSVG from '../../asstes/wordpress.svg';
import unbounceSVG from '../../asstes/Unbounce.svg';
import adobeTargetSVG from '../../asstes/adobe target.svg';
import vwoSVG from '../../asstes/vwo.svg';
import kameleoonSVG from '../../asstes/kameleoon.svg';
import convertSVG from '../../asstes/convert.svg';
import clickfunnelsSVG from '../../asstes/clickfunnels.svg';
import sitefinitySVG from '../../asstes/sitefinity-tech.svg';
import marketoSVG from '../../asstes/marketo-tech.svg';
import hubspotSVG from '../../asstes/hubspot-tech.svg';

export default function CroTicker() {
    return (
        <div className="cro-trusted-ticker">
            <div className="cro-section-label">Trusted by leading eCommerce brands</div>
            <div className="cro-ticker-wrapper">
                <div className="cro-ticker-fade cro-ticker-fade--left"></div>
                <div className="cro-ticker-track">
                    {[...Array(4)].map((_, i) => (
                        <React.Fragment key={i}>
                            {/* Shopify */}
                            <div className="ticker-brand">
                                <img src={shopifySVG} alt="Shopify" />
                            </div>
                            {/* WooCommerce */}
                            <div className="ticker-brand">
                                <img src={woocommerceSVG} alt="WooCommerce" />
                            </div>
                            {/* Webflow */}
                            <div className="ticker-brand">
                                <img src={webflowSVG} alt="Webflow" />
                            </div>
                            {/* BigCommerce */}
                            <div className="ticker-brand">
                                <img src={bigcommerceSVG} alt="BigCommerce" />
                            </div>
                            {/* Google Analytics */}
                            <div className="ticker-brand">
                                <img src={googleAnalyticsSVG} alt="Google Analytics" />
                            </div>
                            {/* PrestaShop */}
                            <div className="ticker-brand">
                                <img src={prestashopSVG} alt="PrestaShop" />
                            </div>
                            {/* Optimizely */}
                            <div className="ticker-brand">
                                <img src={optimizelySVG} alt="Optimizely" />
                            </div>
                            {/* Wix */}
                            <div className="ticker-brand">
                                <img src={wixSVG} alt="Wix" />
                            </div>
                            {/* WordPress */}
                            <div className="ticker-brand">
                                <img src={wordpressSVG} alt="WordPress" />
                            </div>
                            {/* Unbounce */}
                            <div className="ticker-brand">
                                <img src={unbounceSVG} alt="Unbounce" />
                            </div>
                            {/* Adobe Target */}
                            <div className="ticker-brand">
                                <img src={adobeTargetSVG} alt="Adobe Target" />
                            </div>
                            {/* VWO */}
                            <div className="ticker-brand">
                                <img src={vwoSVG} alt="VWO" />
                            </div>
                            {/* Kameleoon */}
                            <div className="ticker-brand">
                                <img src={kameleoonSVG} alt="Kameleoon" />
                            </div>
                            {/* Convert */}
                            <div className="ticker-brand">
                                <img src={convertSVG} alt="Convert" />
                            </div>
                            {/* Clickfunnels */}
                            <div className="ticker-brand">
                                <img src={clickfunnelsSVG} alt="Clickfunnels" />
                            </div>
                            {/* Sitefinity */}
                            <div className="ticker-brand">
                                <img src={sitefinitySVG} alt="Sitefinity" />
                            </div>
                            {/* Marketo */}
                            <div className="ticker-brand">
                                <img src={marketoSVG} alt="Marketo" />
                            </div>
                            {/* Hubspot */}
                            <div className="ticker-brand">
                                <img src={hubspotSVG} alt="Hubspot" />
                            </div>
                        </React.Fragment>
                    ))}
                </div>
                <div className="cro-ticker-fade cro-ticker-fade--right"></div>
            </div>
        </div>
    );
}

